<template>
  <div id="formas-pagamento-franquia-modal-app">
    <modal
      elem-id="modal_formas_pagamento_franquia"
      size="small"
      :close-label="t('Fechar')"
      :save-label="t('Salvar')"
      :save-fn="handleSave"
      :title="item?.forma_pagamento_nome ?? ''"
      :show="isVisible"
      @close="fechar"
      @dismiss="fechar"
    >
      <template v-if="isVisible && item">
        <div class="text-right" style="margin-bottom: 20px;" v-if="temAplicacao">
          <Button
            :label="t('Restaurar padrão')"
            icon="pi pi-undo"
            severity="secondary"
            outlined
            no-explanation="o rótulo diz o que acontece: a franquia volta a herdar o padrão"
            data-testid="fpf-btn-restaurar"
            @click="restaurar" />
        </div>
        <formas-pagamento-franquia-form
          ref="formRef"
          :item="item"
          :franquia-id="franquiaId"
          @save-success="fechar">
        </formas-pagamento-franquia-form>
      </template>
    </modal>
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import FormasPagamentoFranquiaForm from './FormasPagamentoFranquiaForm.vue';
import { eventBus } from '../../eventBus';
import { useFormasPagamento } from '../../composables/useFormasPagamento';
import { temAplicacaoNaFranquia } from './formasPagamentoFranquia';
import { log } from '../../utils/DebugLogger';
import type { FormasPagamentoFranquia_ItemRow } from '../../contracts/FormasPagamentoFranquia_ItemRow';

interface OpenPayload {
  item: FormasPagamentoFranquia_ItemRow;
  franquiaId: number;
}

const { t } = useI18n();
const { removerAplicacao } = useFormasPagamento();

const isVisible = ref<boolean>(false);
const item = ref<FormasPagamentoFranquia_ItemRow | null>(null);
const franquiaId = ref<number>(0);
const formRef = ref<{ salvar: () => Promise<void> } | null>(null);

const temAplicacao = computed<boolean>(() => !!item.value && temAplicacaoNaFranquia(item.value));

const abrir = (payload?: OpenPayload): void => {
  if (!payload) return;
  item.value = payload.item;
  franquiaId.value = payload.franquiaId;
  isVisible.value = true;
};

const fechar = (): void => {
  isVisible.value = false;
  item.value = null;
};

const handleSave = async (): Promise<void> => {
  await formRef.value?.salvar();
};

const restaurar = async (): Promise<void> => {
  if (!item.value) return;
  try {
    await removerAplicacao({ forma_pagamento_id: item.value.forma_pagamento_id, franquia_id: franquiaId.value });
    fechar();
  } catch (error) {
    log('FormasPagamentoFranquiaModal', 'restaurar', 'Error', error);
    eventBus.emit('globalMessage.error', t('Erro ao restaurar o padrão da forma de pagamento'));
  }
};

onMounted(() => eventBus.on('modal.formas-pagamento-franquia.open', abrir));
onBeforeUnmount(() => eventBus.off('modal.formas-pagamento-franquia.open', abrir));
</script>
